import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
// @mui
import {
  Grid,
  Container,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Card,
  CardHeader,
  Box,
  Divider,
} from '@mui/material';
// sections
import Skeleton from '@mui/material/Skeleton';
import { AppRtspList, AppWidgetSummary } from '../../sections/@dashboard/app';
import axiosInstance from '../../utils/axiosInstance';

// ----------------------------------------------------------------------

export default function NvStreamerDashboard() {
  const hostList = useSelector((state) => state.app.hostList);
  const sensorList = useSelector((state) => state.app.sensorList);
  const [vstDevice, setVstDevice] = useState(hostList.length > 0 ? hostList[0] : null);
  const [activeConnections, setActiveConnections] = useState(null);
  const [bitrate, setBitrate] = useState(null);
  const [forceRefresh, setForcedRefresh] = useState(true);

  const handleVstDeviceChange = (e) => {
    setVstDevice(e.target.value);
  };

  useEffect(() => {
    axiosInstance
      .get(`${window.location.protocol}//${window.location.host}/api/v1/sensor/qos`)
      .then(async (response) => {
        if (response.data) {
          if (Object.prototype.hasOwnProperty.call(response.data, 'numActiveRtspConnections')) {
            setActiveConnections(response.data.numActiveRtspConnections);
          }
          if (Object.prototype.hasOwnProperty.call(response.data, 'rtspServerTxBitrate')) {
            setBitrate(response.data.rtspServerTxBitrate);
          }
        }
      })
      .catch((error) => {
        console.log('Failed to get QOS', error);
      });
  }, [forceRefresh]);

  window.refreshDashboardNvStreamer = () => {
    console.log('Forced refresh nvstreamer');
    setForcedRefresh(false);
    setTimeout(() => {
      setForcedRefresh(true);
    }, 500);
  };

  return (
    <>
      <Helmet>
        <title> Dashboard | VST UI </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6}>
            {forceRefresh && (
              <AppWidgetSummary title={`${window.adaptorType} devices`} total={hostList.length} icon={'mdi:memory'} />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            {forceRefresh && (
              <AppWidgetSummary title="Video files" total={sensorList.length} color="info" icon={'lucide:file-video'} />
            )}
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>

          <Grid item xs={12}>
            <Card>
              <CardHeader title={`${window.adaptorType} devices`} subheader={`Select ${window.adaptorType} device`} />
              <Box sx={{ p: 3, pb: 1 }} dir="ltr">
                <FormControl>
                  <RadioGroup row name="vst-device-radio-button" value={vstDevice} onChange={handleVstDeviceChange}>
                    {hostList.map((host) => (
                      <FormControlLabel
                        value={host}
                        control={<Radio />}
                        label={`${window.adaptorType} ${host}`}
                        key={host}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Box>
            </Card>
          </Grid>
          {forceRefresh && (
            <Grid item xs={12} md={12} lg={12}>
              <AppRtspList
                title="RTSP URLs"
                subheader={
                  <Typography variant="caption" sx={{color: "#637381"}}>
                    <span># Connections: {activeConnections}</span><br/>
                    <span>Total Tx Bitrate: {bitrate}</span>
                  </Typography>
                }                host={vstDevice}
                rowCount={5}
              />
            </Grid>
          )}
          {!forceRefresh && (
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                <Skeleton variant="rounded" height={300} />
              </Card>
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}
